/// <reference types="vite/client" />
export const APP_ENVIRONMENTS = [
  "development",
  "staging",
  "production",
] as const;

export type AppEnvironment = (typeof APP_ENVIRONMENTS)[number];

export function parseAppEnvironment(
  value: string | undefined,
): AppEnvironment {
  if (value === "staging" || value === "production" || value === "development") {
    return value;
  }
  return "development";
}

export function getAppEnvironment(): AppEnvironment {
  return parseAppEnvironment(import.meta.env.VITE_APP_ENV);
}

/** Staging and local dev; not the public production deploy. */
export function isNonProductionApp(): boolean {
  return getAppEnvironment() !== "production";
}

export function getEnvironmentBadgeEnv(env: AppEnvironment): string {
  return env === "development" ? "localhost" : env;
}

export function getEnvironmentLabel(env: AppEnvironment): string {
  if (env === "development") {
    return "LOCALHOST";
  }
  return env.toUpperCase();
}
